import { sendCustomEventAnalytics } from "./analytic-init-logic.js";

const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
const AUTH_ENDPOINT = process.env.AUTH_ENDPOINT;
const REDIRECT_URL = process.env.REDIRECT_AUTH_URL;

//init Google GSI
function initGoogleOneTap() {
  //check Google GSI is loaded
  if (typeof google !== "undefined" && google.accounts) {
    setupGoogleOneTap();
  } else {
    const checkGoogleLoaded = setInterval(() => {
      if (typeof google !== "undefined" && google.accounts) {
        clearInterval(checkGoogleLoaded);
        setupGoogleOneTap();
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkGoogleLoaded);
      console.warn("Google GSI is not loaded");
    }, 10000);
  }
}

async function setupGoogleOneTap() {
  google.accounts.id.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: handleCredentialResponse,
    cancel_on_tap_outside: false,
    auto_select: false,
  });

  //prompt Google GSI
  google.accounts.id.prompt((notification) => {
    if (notification.isNotDisplayed()) {
      console.log(
        "One Tap is not displayed: ",
        notification.getNotDisplayedReason(),
      );
    }
  });
}

async function handleCredentialResponse(response) {
  try {
    await sendAnalyticsEvent(response);
    const authResult = await authenticateWithBackend(response.credential);
    setTimeout(() => redirectToApp(authResult), 1000);
  } catch (error) {
    console.error("Error Google One Tap: ", error);
  }
}

async function sendAnalyticsEvent(response) {
  const urlParams = new URLSearchParams(window.location.search);

  sendCustomEventAnalytics({
    event: "auto_signin_google",
    landing_url: location.hostname + location.pathname,
    platform: "web",
    utm_source: urlParams.get("utm_source") || "",
    full_url: location.href,
  });
}

//authenticate with backend
async function authenticateWithBackend(credential) {
  try {
    const response = await fetch(AUTH_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        idToken: credential,
        name: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to authenticate: ${response.status}`);
    }

    const authResult = await response.json();

    return {
      success: true,
      token: authResult.accessToken,
      isNew: authResult.isNew,
    };
  } catch (error) {
    console.error("Error authenticate with backend: ", error);
    return { success: false, error: error.message };
  }
}

function redirectToApp(authResult) {
  if (authResult.success) {
    let FINAL_REDIRECT_URL = REDIRECT_URL + `&isNew=${authResult.isNew}`;
    if (process.env.PAYMENT_GROUP) {
      FINAL_REDIRECT_URL += `&payment_group=${process.env.PAYMENT_GROUP}`;
    }
    window.location.href = FINAL_REDIRECT_URL;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initGoogleOneTap();
});

export { initGoogleOneTap };
